<template>
    <div class="background-supplement-no-title-layout">
        <div class="layout-content" v-loading="loading" v-if="amounts">
            <div class="amount-wrap">
                <div class="amount-total">
                    <span class="amount-text">{{ totalValue }}</span>课时
                    <el-button type="primary" @click="buyHours" class="cashing">购买课时</el-button>
                </div>
                <ul class="detail-wrap">
                    <li v-for="(item, index) in detailRemainValue" :key="index" class="detail-item">
                        <p>
                            <span class="num">{{ item.remainValue+ item.freezeValue }}</span>
                            <span class="show">{{ item.hourName }}</span>
                        </p>
                        <div style="text-align:center;">已预约{{ item.freezeValue }}课时</div>
                    </li>
                </ul>
            </div>
            <ul class="periods-list">
                <li v-for="(list, index) in amounts" :key="index">
                    <div class="list-left" style="width:80%">
                        <div>
                            <el-popover
                                placement="bottom-start"
                                width="auto"
                                trigger="hover"
                                :content="list.remark">
                                <span slot="reference" class="cost-space-text">
                                    <span v-if="list.moneyAmount < 0" class="pay">{{ list.remarkStr }}</span>
                                    <span v-else class="in">{{ list.remarkStr }}</span>
                                </span>
                            </el-popover>
                            <p> {{ formatDate(list.time) }}</p>
                        </div>
                    </div>
                    <div class="list-right">
                        <span v-if="list.recordStyle === 4 && list.pendingOrderStatus === 1" class="pay-button" @click="goPayment(list)">去支付</span>
                        <span v-else-if="list.recordStyle === 4 && list.pendingOrderStatus === 2" class="payment-info">已支付</span>
                        <span v-else class="update-package">
                            <span class="count">{{ list.amount > 0 ? "+"+list.amount : list.amount }}</span>
                            <span class="info">{{ list.classPackageLevel }}课时包</span>
                        </span>
                    </div>
                </li>
            </ul>
            <div class="page">
                <el-pagination v-if="total > 20"
                    style="text-align:center"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="20"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <div v-else class="layout-content">
            <div class="no-purchase">
            <img src="../../../assets/images/record/history_icon_curriculum.png" alt="">
            <p>
                <span class="no-page">您还没有课时!</span><br/>
                <span class="number">如想购买好分数辅导相关课程<br/>请联系好分数客服 4008180190</span>
            </p>
            </div>
        </div>
    </div>
</template>
<script>
import Moment from 'moment';
import _ from 'lodash';
import Enums from '../../../constants/enum.js';
import { mapMutations } from 'vuex';
export default{
    data() {
        return {
            flag: true,
            loading: false,
            currentPage: 1,
            start: 0,
            limit: 20,
            amounts: [],
            total: '',
            totalValue: 0, // 全部课时
            remainValue: '', // 剩余课时
            Enums: Enums,
            hourNameObj: {
                1: '基础课时',
                2: '高级课时',
                3: 'VIP课时'
            },
            detailRemainValue: []
        };
    },
    beforeMount() {
        this.getPeriod();
    },
    methods: {
        ...mapMutations(['PAYMENT_PACKAGE_GOOD']),
        handleCurrentChange(page) {
            this.currentPage = page;
            this.getPeriod();
        },
        /**
         * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=56393898#hfsfd-be%E6%94%AF%E4%BB%98%E4%BF%A1%E6%81%AFAPI-%E8%8E%B7%E5%8F%96%E8%AF%BE%E6%97%B6%E4%BA%A4%E6%98%93%E8%AE%B0%E5%BD%95
         * */
        getPeriod() {
            if (this.flag) {
                this.flag = false;
                this.loading = true;
                let limit = this.limit;
                this.$http
                    .get('/v1/payments/periods/records', {
                        params: {
                            start: (this.currentPage - 1) * limit,
                            limit
                        }
                    })
                    .then(resp => this.$checkResp(resp, {}))
                    .then(data => {
                        if (data) {
                            let teachersUsername = [];
                            data.records.forEach(item => {
                                let info = item.remark.split('#Re')[0];
                                item.username = item.remark.split('@')[1];
                                if (item.username) {
                                    teachersUsername.push(item.username);
                                };
                                item.remarkStr = info;
                                item.classPackageLevel = Enums.StandardClassPackageLevel[_.get(item, 'levelInfo[0].level', 0)];
                            });
                            if (teachersUsername.length) {
                                this.getTeachersId(teachersUsername);
                            }
                            this.amounts = data.records;
                            this.total = data.total;
                            // 剩余课时
                            this.remainValue = data.remainValue || 0;
                            this.detailRemainValue = data.standardClassPackagePeriod;
                            this.detailRemainValue.sort((a, b) => a.level - b.level);
                            this.detailRemainValue.forEach(item => {
                                item.hourName = this.hourNameObj[item.level];
                            });
                            let otherCourse = {};
                            otherCourse.remainValue = data.otherRemainPeriod || 0;
                            otherCourse.freezeValue = data.freezeOtherRemainPeriod || 0;
                            this.detailRemainValue.push(otherCourse);
                            this.detailRemainValue.forEach(item => {
                                let total = item.remainValue + item.freezeValue;
                                this.totalValue += total;
                            });
                        }
                    }).catch(err => {
                        this.$handleError(err.msg);
                    }).finally(() => {
                        this.flag = true;
                        this.loading = false;
                    });
            }
        },
        formatDate(date) {
            return date ? Moment(date).format('YYYY-MM-DD HH:mm:ss') : '';
        },
        getTeachersId(arr) {
            this.$http
                .post('/v1/teachers/convert/username', { username: arr })
                .then(resp => this.$checkResp(resp, {}))
                .then(data => {
                    let teachersId = [];
                    for (let key in data) {
                        teachersId.push(data[key]);
                    }
                    if (teachersId.length) {
                        this.getTeachersInfo(teachersId);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                });
        },
        getTeachersInfo(arr) {
            let teachersIdStr = arr.join(',');
            this.$http
                .get(`/v1/teachers/basic-info-list?teacherIds=${teachersIdStr}`)
                .then(resp => this.$checkResp(resp, {}))
                .then(data => {
                    if (data.length) {
                        this.amounts.forEach(item => {
                            if (item.username) {
                                let teacherInfo = data.filter(info => info.username === item.username);
                                item.remarkStr += `老师：${teacherInfo[0].familyName}老师`;
                            };
                        });
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                });
        },
        // 购买课时
        buyHours() {
            this.$router.push({
                name: 'purchase@record'
            });
        },
        // 去升级支付
        goPayment(item) {
            this.$router.push({
                name: 'charge@package',
                query: {
                    pendingOrderId: item.pendingOrderId
                }
            });
        }
    }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .layout-content {
        padding: 30px;
    }

    .amount-wrap {
        width: 100%;
        height: 160px;
        background: url('../../../assets/images/common/hour_img_bg.png') no-repeat center;
        background-size: cover;
        color: #fff;
        font-size: 14px;
        margin-bottom: 30px;
        position: relative;
        padding: 30px 0;
        .amount-total{
            padding:0 53px 0 50px;
            font-family: PingFangSC-Medium;
            font-size: 20px;
            color: #FFF;
            font-weight: 550;
            .amount-text{
                font-size: 40px;
                margin-right:10px;
            }
        }

        .detail-wrap {
            margin-top: 8px;
            display: flex;
            .detail-item {
                flex:1;
                align-items: center;
                border-left: 1px solid rgba(255, 255, 255,.3);
                &:first-child{
                    border:none;
                }
                p {
                    text-align: center;
                    .num {
                        font-family: PingFangSC-Medium;
                        font-size: 22px;
                        color: #fff;
                        letter-spacing: 0;
                        line-height: 33px;
                        margin-bottom: 10px;

                    }

                    .show {
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #fff;
                        letter-spacing: 0;
                        line-height: 20px;
                        display: inline-block;
                    }
                }
            }
        }

        .cashing {
            background-image: linear-gradient(-269deg, #f44b4b 0%, #ff943b 100%);
            box-shadow: 0 4px 10px 0 rgba(244, 76, 75, 0.43);
            border-radius: 15px;
            position: absolute;
            right: 53px;
            top: 37px;
            outline: none;
            font-size: 12px;

            &:focus {
                outline: 0;
            }
        }

        /deep/ .el-button--primary {
            border: none;
            padding: 9px 11px;
        }
    }

    .periods-list {
        padding: 0 12px;

        li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #e6e6e6;
            padding-bottom: 21px;
            margin-bottom: 19px;
        }

        .cost-space-text {
            font-size: 14px;
            color: #4e3f3c;
            line-height: 20px;
            display: inline-block;
        }

        p {
            font-size: 12px;
            color: #bfb2b0;
            line-height: 17px;
            margin-top: 5px;
        }

        .list-right {
            font-size: 14px;
            color: #333;
            display: flex;
            flex-flow: column;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;

            .package {
                color: #666;
                font-size: 12px;
                margin-top: 10px;
            }

            .pay-button {
                display: inline-block;
                width: 70px;
                height: 26px;
                background: rgba(244, 102, 75, 0.1);
                border-radius: 13px;
                text-align: center;
                line-height: 26px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #f4664b;
                letter-spacing: 0;
                cursor: pointer;
            }

            .payment-info {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #f4664b;
            }

            .update-package {
                display: flex;
                justify-content: center;
                flex-direction: column;

                .count {
                    font-family: PingFangSC-Medium;
                    font-size: 14px;
                    color: #4e3f3c;
                    letter-spacing: 0;
                    text-align: right;
                    padding-bottom: 5px;
                }

                .info {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #766864;
                    text-align: right;
                }
            }
        }
    }

    .page {
        margin-top: 30px;
        width: 100%;
        text-align: right;
    }

    .notice {
        height: 14px;
        font-size: 12px;
        color: #8898af;
        line-height: 20px;
        position: absolute;
        right: 30px;
        top: 25px;

        i {
            background: url(../../../assets/images/common/nav_Prompt.png) no-repeat left 0;
            background-size: contain;
            width: 12px;
            height: 14px;
            display: inline-block;
            margin-right: 10px;
            vertical-align: text-bottom;
        }
    }

    .no-purchase {
        width: 200px;
        margin: 0 auto;
        text-align: center;
        margin-top: 18%;

        img {
            width: 170px;
            height: 170px;
        }

        p {
            .no-page {
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #999;
                text-align: center;
                margin-bottom: 10px;
                display: inline-block;
            }

            .number {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #ccc;
                text-align: center;
                line-height: 17px;
                display: inline-block;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/index/components/RecordPeriod.vue